import { routes } from '@linqpal/models'

interface IMakeGuestCardPaymentParams {
  user: {
    firstName: string
    lastName: string
    phone: string
    email: string
  }
  invoiceId: string
  company: {
    name: string
    isBusiness: boolean
  }
  payment: {
    invoiceAmount: number
    fee: number
    totalAmount: number
  }
  bankAccountId: string
}

export const makeGuestCardPayment = async (
  data: IMakeGuestCardPaymentParams,
) => {
  try {
    const response = await routes.guest.payInvoice(data)

    return response
  } catch (err) {
    console.error(err)
    return err
  }
}
